import { render, staticRenderFns } from "./AttrList.vue?vue&type=template&id=03e254b2&scoped=true&"
import script from "./AttrList.vue?vue&type=script&lang=js&"
export * from "./AttrList.vue?vue&type=script&lang=js&"
import style0 from "./AttrList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AttrList.vue?vue&type=style&index=1&id=03e254b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e254b2",
  null
  
)

export default component.exports